import React from 'react';
import './TermsAndConditions.css';

const legalPolicies = {
  termsAndConditions: {
    title: "Terms & Conditions",
    sections: [
      {
        id: 1,
        title: "Introduction",
        content: "These Terms and Conditions (\"Terms\") govern your access and use of Shutter Labs (\"we\", \"us\", or \"our\") services, including the website, platform, and tools we offer (\"Solution\"). By using the Solution, you agree to comply with these Terms."
      },
      {
        id: 2,
        title: "Definitions",
        content: [
          "Account: A dedicated space for each registered user.",
          "Client: Any legal or natural person who enters into a contract with Shutter Labs.",
          "User: Any person accessing or using the platform.",
          "Input: All content, data, and information submitted by users.",
          "Output: All content generated by our platform.",
          "Downloaded Output: Any Output downloaded by clicking the \"Download\" button."
        ]
      },
      {
        id: 3,
        title: "Use of the Platform",
        content: [
          "You agree to:",
          "Use the platform legally and ethically.",
          "Not upload infringing, obscene, or harmful content.",
          "Prevent unauthorized access to your Account.",
          "Not reverse engineer, copy, or replicate the Solution."
        ]
      },
      {
        id: 4,
        title: "Payments",
        content: "All payments are final and non-refundable, regardless of usage."
      },
      {
        id: 5,
        title: "Ownership & Intellectual Property",
        content: [
          "Users retain ownership of their Inputs.",
          "By using our service, you grant Shutter Labs a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and process Inputs to:",
          "Provide and improve our services.",
          "Train and fine-tune our AI models.",
          "Shutter Labs retains full ownership of the Output and any intellectual property derived from it, unless otherwise agreed in writing."
        ]
      },
      {
        id: 6,
        title: "Data Tracking",
        content: [
          "We track user interactions, including usage patterns, IP addresses, browser information, and generated content to:",
          "Improve user experience.",
          "Detect abuse.",
          "Enhance model performance."
        ]
      },
      {
        id: 7,
        title: "Account Suspension and Termination",
        content: [
          "We may suspend or terminate your access if:",
          "You violate any of these Terms.",
          "There is suspicious, excessive, or abusive behavior."
        ]
      },
      {
        id: 8,
        title: "Disclaimers & Limitation of Liability",
        content: [
          "All services are provided \"as-is\" without any warranties.",
          "We are not liable for inaccuracies, loss of data, or any harm resulting from the use of the platform."
        ]
      },
      {
        id: 9,
        title: "Governing Law",
        content: "These Terms are governed by the laws of the State of Texas, United States."
      }
    ]
  },
  privacyPolicy: {
    title: "Privacy Policy",
    sections: [
      {
        id: 1,
        title: "Data We Collect",
        content: [
          "Personal identifiers (e.g., email, name)",
          "Usage data (e.g., pages visited, IP address)",
          "Input content",
          "Activity logs and session metadata"
        ]
      },
      {
        id: 2,
        title: "How We Use Data",
        content: [
          "To operate and maintain our services",
          "To personalize and improve your experience",
          "For analytics, research, and development",
          "To comply with legal obligations"
        ]
      },
      {
        id: 3,
        title: "Data Sharing",
        content: [
          "We do not sell personal data. We may share it with:",
          "Sub-processors and service providers",
          "Legal authorities when required"
        ]
      },
      {
        id: 4,
        title: "Data Retention",
        content: "We retain data as long as necessary to fulfill service obligations or comply with laws. Inputs and Outputs may be stored indefinitely to improve our models."
      },
      {
        id: 5,
        title: "User Rights",
        content: [
          "You may request:",
          "Access to your data",
          "Correction or deletion (subject to legal exemptions)",
          "To withdraw consent to processing (where applicable)"
        ]
      },
      {
        id: 6,
        title: "Cookies and Tracking",
        content: "See Cookies Policy below."
      }
    ]
  },
  cookiesPolicy: {
    title: "Cookies Policy",
    sections: [
      {
        id: 1,
        title: "What Are Cookies?",
        content: "Cookies are small data files stored on your device that help enhance your experience."
      },
      {
        id: 2,
        title: "How We Use Cookies",
        content: [
          "Essential cookies for authentication and session management",
          "Analytics cookies to track usage patterns",
          "Preference cookies to remember settings"
        ]
      },
      {
        id: 3,
        title: "Managing Cookies",
        content: "You can adjust your browser settings to block or delete cookies. Note: disabling cookies may limit certain features."
      }
    ]
  }
};

const renderContent = (content) => {
  if (Array.isArray(content)) {
    return (
      <ul>
        {content.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  }
  return <p>{content}</p>;
};

const TermsAndConditionsPage = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <header className="terms-header">
          <h1>Shutter Labs Legal Policies</h1>
          <p>Last updated: January 2025</p>
        </header>

        <div className="terms-content">
          {/* Terms & Conditions */}
          <section className="policy-section">
            <h2>{legalPolicies.termsAndConditions.title}</h2>
            {legalPolicies.termsAndConditions.sections.map((section) => (
              <div key={section.id} className="section">
                <h3>{section.title}</h3>
                {renderContent(section.content)}
              </div>
            ))}
          </section>

          {/* Privacy Policy */}
          <section className="policy-section">
            <h2>{legalPolicies.privacyPolicy.title}</h2>
            {legalPolicies.privacyPolicy.sections.map((section) => (
              <div key={section.id} className="section">
                <h3>{section.title}</h3>
                {renderContent(section.content)}
              </div>
            ))}
          </section>

          {/* Cookies Policy */}
          <section className="policy-section">
            <h2>{legalPolicies.cookiesPolicy.title}</h2>
            {legalPolicies.cookiesPolicy.sections.map((section) => (
              <div key={section.id} className="section">
                <h3>{section.title}</h3>
                {renderContent(section.content)}
              </div>
            ))}
          </section>

          <div className="contact-info">
            <p>For any legal concerns, contact us at <a href="mailto:support@shutterlabs.app">support@shutterlabs.app</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage; 